<template>
  <div :style="isStatic ? {pointerEvents: 'none'} : null">
    <div
      ref="chart"
      :class="'js_export_report_dymanic_chart'"
    />
    <div
      v-if="showStubText"
      :class="$.stub_description"
      :style="{width: width, left: leftPos}"
    >
      <div :class="$.text">
        {{ locales(`report_page_no_filtered_data`) }}
      </div>
    </div>
    <div
      v-if="legendItems.length"
      :class="[$.legend, 'export_html_legend']"
      :style="{width: width, left: leftPos}"
    >
      <div
        v-for="(item, index) in legendItems"
        :key="index"
        :class="[
          $.wrapper,
          'export_html_legend_item',
          disabledSeries[item.name] && 'disabled'
        ]"
        @click="toggleSelect(item.name)"
      >
        <div
          :class="[$.box, 'export_html_box']"
          :style="{background: item.color}"
        />
        <div :class="[$.name, 'export_html_name']">
          {{ item.label }}
        </div>
      </div>
    </div>
    <div
      v-if="chartName.length"
      :class="[$.legend, $.chart_name, 'export_html_chart_name_bottom']"
      :style="{width: width}"
    >
      {{ chartName }}
    </div>
  </div>
</template>

<script>
import * as echarts from '../../../libs/echarts';

export default {
  props: {
    config: { type: Array, required: true },
    stubConfig: { type: Array, required: true },
    isStatic: { type: Boolean, required: true, default: false },
    isDisabled: { type: Boolean, required: true, default: false },
    legendItems: { type: Array, required: true, default: () => [] },
    isSingleProject: { type: Boolean, required: true, default: false },
    chartName: { type: String, required: false, default: '' },
    showStubMessage: { type: Boolean, required: false, default: false },
  },
  emits: { toggleChart: String },
  data() {
    return {
      id: 'chart',
      locales: __,
      instance: null,
      labelBehind: __('reports_chart_bar_negative'),
      labelAhead: __('reports_chart_bar_positive'),
      width: '100%',
      leftPos: 0,
      timeout: null,
      disabledSeries: {},
      isMounted: false,
    };
  },
  computed: {
    leftSidebarWidth() {
      return this.$store.getters.leftSidebarWidth;
    },
    showStubText() {
      return (this.isStatic || this.isDisabled) && this.showStubMessage;
    },
  },
  watch: {
    config: {
      handler(conf) {
        if (conf) {
          setTimeout(() => {
            const modified = this.modifiedConfig(conf);

            this.instance.setOption(modified);
            setTimeout(() => this.onResize(), 0);
          }, 0);
        }
      },
      immediate: true,
    },
    isStatic: {
      handler(flag) {
        if (!this.instance) {
          return;
        }
        this.instance.setOption(this.stubConfig);
        setTimeout(() => this.onResize(), 0);
      },
      immediate: true,
    },
    isDisabled: {
      handler(flag) {
        if (!this.instance) {
          return;
        }
        this.instance.setOption(this.stubConfig);
        setTimeout(() => this.onResize(), 0);
      },
      immediate: true,
    },
    leftSidebarWidth() {
      this.onResize();
    },
  },
  mounted() {
    this.instance = echarts.init(this.$refs.chart);
    this.instance.setOption(this.stubConfig);
    this.onResize();
    this.isMounted = true;

    window.addEventListener('resize', this.onResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
    echarts.dispose(this.instance);
  },
  methods: {
    onResize() {
      const chartWidth = this.$refs.chart.clientWidth;
      const width = document.documentElement.clientWidth - this.leftSidebarWidth;
      const stubHeight = (document.documentElement.clientHeight - 130) / 2;
      const height = document.documentElement.clientHeight - 130;

      if (!this.isMounted || this.isStatic || this.isDisabled || this.isSingleProject) {
        this.instance.resize({ width, height: stubHeight });
      } else {
        this.instance.resize({ width, height });
      }

      this.width = `${chartWidth}px`;
      this.leftPos = `${this.leftSidebarWidth}px`;
    },
    toggleSelect(name) {
      if (name in this.disabledSeries) {
        delete this.disabledSeries[name];
      } else {
        this.disabledSeries[name] = true;
      }

      this.$emit('toggleChart', name);
    },
    modifiedConfig(config) {
      const hasConfig = config && Object.keys(config).length;
      const currentConfig = hasConfig ? config : this.stubConfig;
      const modified = { ...currentConfig };

      if (modified.yAxis.data.length > 20) {
        modified.yAxis.axisLabel.show = false;
        modified.grid = { left: 100 };
      }

      return modified;
    },
  },
};
</script>
<style module="$" lang='less'>
@import '../../../less/_mixins.less';
@import '../../../less/_fonts.less';
.stub_description {
  display: flex;
  justify-content: center;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);

  .text {
    color: #191919;
    opacity: .5;
    .FontLatoRegular;
    font-size: 18px;
    text-align: center;
    background: #fff;
    padding: 10px;
  }
}

.legend {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  position: fixed;
  bottom: 52px;

  &.chart_name {
    position: relative;
    .FontLatoRegular;
    color: #191919;
    font-size: 16px;
    padding: 0 40px;
    padding-top: 76px;

    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 5 !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal !important;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    .icon {
      display: flex;
      align-items: center;
    }

    .box {
      width: 35px;
      height: 20px;
      border-radius: 2px;
    }

    .name {
      .FontLatoRegular;
      font-size: 16px;
      color: #191919;
      padding-left: 8px;
    }

    &:not(:last-child) {
      margin-right: 24px;
    }
  }
}
</style>
